import dayjs, { type Dayjs } from 'dayjs'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'

import { TZ } from '../constants/date.constants'

dayjs.extend(timezone)
dayjs.extend(utc)

export const MONTH_YEAR_FORMAT = 'YYYY-MM'

export const formatDate = (date: string | Dayjs) => dayjs(date).format('DD. MM. YYYY')
export const formatDateTime = (date: string | Dayjs) => dayjs(date).format('DD. MM. YYYY HH:mm')
export const formatDateWithDayName = (date: string | Dayjs) => dayjs(date).format('dddd, DD. MM.')

export const dateToMonthYear = (date: Dayjs | string) => dayjs(date).format(MONTH_YEAR_FORMAT)
export const monthYearToDate = (identifier: string) => {
  return dayjs.tz(identifier, MONTH_YEAR_FORMAT, TZ)
}
